<template>
    <v-container fluid ma-0 pa-0>
        <v-row justify="center" align="center" fill-height>
            <v-col clos="12">
                <logIn v-if="displayMap.showSignIn"></logIn>
                <signUp v-if="displayMap.showSignUp" isCognitoReg = "true"></signUp>
                <forgotPassword v-if="displayMap.showForgotPassword"></forgotPassword>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    const signUp = ()=> import( '@/components/common/cognito/SignUp');
    const logIn = ()=> import( '@/components/common/cognito/LogIn');
    const forgotPassword = ()=> import( '@/components/common/cognito/ForgotPassword');
    import { AmplifyEventBus }  from 'aws-amplify-vue';

    export default {
        name: "Authentication",
        components: {
            signUp, logIn, forgotPassword
        },
        data() {
            return {
                displayMap: {}
            }
        },
        methods: {
            updateDisplayMap: state => {
                return {
                    showSignIn: (state === 'signedOut' || state === 'signedIn'),
                    showSignUp: state === 'signUp',
                    showConfirmSignUp: state === 'confirmSignUp',
                    showConfirmSignIn: state === 'confirmSignIn',
                    showForgotPassword: state === 'forgotPassword',
                    //commented until we have our singOut page
                //    showSignOut: state === 'signedIn',
                    showMfa: state === 'setMfa'
                }
            },
        },
        async mounted() {
            AmplifyEventBus.$on('authState', data => {
                this.displayMap = this.updateDisplayMap(data);
                return;
            });

           const user = this.$store.getters.getUser;
           if(!!!user){
              this.displayMap = this.updateDisplayMap('signedOut')
           }
        }
    }
</script>

<style scoped>
    .Section__sectionFooterSecondaryContent___3cjOa{
        display: none;
    }

    .row {
        height: 100%;
    }
</style>